<template>
  <div class="course-goods-detail">
    <a-modal
      v-model="buyQrcodeShow"
      title="微信扫码购买"
      :footer="null"
      :maskClosable="false"
      :width="250"
    >
      <qrcode-vue :value="getBuyLink()" :size="200" level="H"></qrcode-vue>
    </a-modal>
    <a-row class="intoduction" type="flex" justify="space-between">
      <a-col :span="8" class="cover">
        <!-- <a-carousel arrows dots-class="slick-dots slick-thumb">
          <a slot="customPaging" slot-scope="props">
            <img :src="getImgUrl(props.i)" />
          </a>
          <div v-for="item in 4">
            <img :src="baseUrl + 'abstract0' + item + '.jpg'" />
          </div>
        </a-carousel> -->
        <img :src="activityInfo.activityCover" alt="" />
      </a-col>
      <a-col :span="15" class="buy">
        <h2>{{ activityInfo.activityName }}</h2>
        <p>{{ activityInfo.activityDesc }}</p>

        <div class="price">
          <a-row>
            <a-col :span="5">价格：</a-col>
            <a-col :span="18"
              ><span class="origianl-pirce"
                >￥ {{ activityInfo.originalPrice / 100 }}</span
              ></a-col
            >
          </a-row>
          <a-row v-if="activityInfo.price != null">
            <a-col :span="5">优惠价：</a-col>
            <a-col :span="18"
              ><span class="sale-price"
                >￥ {{ activityInfo.price / 100 }}</span
              ></a-col
            >
          </a-row>
        </div>
        <!-- <button>收藏</button> -->
        <a-button type="danger" @click="toBuy">{{activityInfo.price == 0? '领取':'购买'}}</a-button>
      </a-col>
    </a-row>
    <div class="content-wrap">
      <!-- <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="商品信息" key="1" forceRender>
          <div class="content-img" v-if="activityInfo.contentType == 1">
            <img :src="activityInfo.landingImgPc" alt />
          </div>
          <div
            class="content-html"
            v-if="activityInfo.contentType == 2"
            v-html="activityInfo.landingHtmlPc"
          ></div>
        </a-tab-pane>
        <a-tab-pane tab="课程设置" key="2" forceRender> </a-tab-pane>
      </a-tabs> -->
      <a-divider>商品信息</a-divider>
      <div class="content-img" v-if="activityInfo.contentType == 1">
        <img :src="activityInfo.landingImgPc" alt />
      </div>
      <div
        class="content-html"
        v-if="activityInfo.contentType == 2"
        v-html="activityInfo.landingHtmlPc"
      ></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { USER_NAME, USER_INFO } from "@/store/mutation-types";
import QrcodeVue from "qrcode.vue";
import { getActivityDetail } from "@/api/goods";
import { getAction } from "@/api/manage";
export default {
  name: "CourseGoodsDetail",
  components: { QrcodeVue },
  data() {
    return {
      actId: "",
      //   userInfo: {},
      //   userId: "",
      activityInfo: {},
      buyQrcodeShow: false,
    };
  },
  created() {
    this.actId = this.$route.query.actId;
    this.userInfo = this.$store.state.user.info;
    // if (this.userInfo === null) {
    // } else {
    //   this.userId = this.userInfo.id;
    // }
    this.getActivityInfo();
  },
  methods: {
    getActivityInfo() {
      getActivityDetail(this.actId).then((res) => {
        this.activityInfo = res.result;
        window.document.title =
          this.activityInfo.landingTitle || this.activityInfo.activityName;
      });
    },
    toBuy() {
      let that = this
      console.log(Vue.ls.get(USER_INFO));
      if (Vue.ls.get(USER_INFO) != null) {
        // if(this.activityInfo.price == 0){
            getAction("/teaching/teachingActivity/freeByActivity?activityId="+this.activityInfo.activityId).then(res=>{
                if(res.success){
                  this.$message.success(res.message)
                  this.$success({
                    title: '领取成功',
                    content: <div>
                      <p>您好，AICE模拟练习试卷默认由一级开始开放练习权限，通过后即可自动开放下一级别试卷，请根据老师的要求和指导，选择对应项目试卷开始答题，答题结束后在“模拟练习（图示截图）”中选择“查看我的模拟练习（图示截图）”了解答题情况。</p>
                    </div>,
                    okText: '查看试卷',
                    onOk() {
                      that.$router.push({path: '/user/myPaper'})
                    },
                  });
                }else{
                    this.$message.info(res.message)
                }
            })
        // }else{
            // this.buyQrcodeShow = true;
        // }
      } else {
        this.$message.error("请先登录");
      }
    },
    getBuyLink() {
      if (Vue.ls.get(USER_INFO) == null) {
        return "";
      }
      let url =
        window.location.protocol +
        "//" +
        window.location.host +
        "/mobile/landing.html?actId=" +
        this.actId +
        "&userId=" +
        Vue.ls.get(USER_INFO).id;
      return url;
    },
  },
};
</script>

<style lang="less">
.course-goods-detail {
  padding: 20px 10%;
  background: #fff;
  .intoduction {
    border: solid #e2e2e2 1px;
    padding: 20px;
    .cover {
      img {
        width: 100%;
      }
    }
    .buy {
      text-align: left;
      .price {
        .ant-row {
          margin-bottom: 10px;
        }
        .origianl-pirce {
          text-decoration: line-through;
        }
        .sale-price {
          color: red;
          font-size: 20px;
        }
      }
    }
  }
  .content-wrap {
    overflow: hidden;
    .content-img {
      img {
        width: 100%;
      }
    }
    .content-html {
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}

.btn-buy {
  color: #e5511d;
  border-color: #f0cab6;
  background: #ffe4d0;
  display: block;
  cursor: pointer;
  width: 134px;
  height: 38px;
  text-align: center;
  font-family: "Hiragino Sans GB", "microsoft yahei", sans-serif;
  font-size: 16px;
  line-height: 38px;
  border-width: 1px;
  border-style: solid;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
}
</style>